

























import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';

import PresetTag from '@/classes/PresetTag';
import IdBadge from '@/components/Misc/IdBadge.vue';
import TagBadge from '@/components/Misc/TagBadge.vue';
import { ITag } from '@/interfaces';
import { upsertList } from '@/main';
import PresetTagsModule from '@/store/modules/PresetTagsModule';

const presetTagsModule = getModule(PresetTagsModule);

export default Vue.extend({
  components: {
    IdBadge,
    TagBadge,
  },
  props: ['isEditing', 'originalCopy'],
  data() {
    return {
      workingCopy: _.cloneDeep(this.originalCopy),
      newTagText: '',
      submitError: '',
    };
  },
  methods: {
    addNewTagFromText(newTagText: string) {
      const newtags = newTagText.split(',').map(($0) => ({ name: $0 }));
      const oldtags = this.workingCopy.tags;
      upsertList<ITag>(oldtags, 'name', newtags);
      this.workingCopy.tags = oldtags;
      this.newTagText = '';
    },
    deleteTag(tag: ITag) {
      this.workingCopy.tags = _.filter(this.workingCopy.tags, ($0) => ($0.name !== tag.name));
    },
    cancel() {
      if (confirm('確定要取消?')) {
        this.workingCopy = _.cloneDeep(this.originalCopy);
        this.$emit('cancel');
      }
    },
    save() {
      presetTagsModule.apiUpdatePresetTag({ presetTag: this.workingCopy }).then((response) => {
        if (response.success === false) {
          this.submitError = response.error.message;
          return;
        }
        this.$emit('saved');
      });
    },
    reset() {
      if (confirm('確定要重置?')) {
        this.workingCopy = _.cloneDeep(this.originalCopy);
      }
    },
  },
});
